import { render } from "./CollectImportFiles.vue?vue&type=template&id=0cf1f356"
import script from "./CollectImportFiles.vue?vue&type=script&lang=js"
export * from "./CollectImportFiles.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__